export default __webpack_public_path__ + "static/media/notification1.6f9bc03b.png";